import React from 'react';
import { connect } from 'react-redux';
import { updateModals, resetModals } from '@panel/avisos/ducks/modals/actions';
import { invalidateCredits } from '@panel/avisos/ducks/credits/actions';
import { publishPosting, resetPublishPosting } from '@panel/avisos/ducks/publish/actions';
import { suspendPosting, resetSuspendPosting } from '@panel/avisos/ducks/suspend/actions';
import { updatePosting } from '@panel/avisos/ducks/posting/actions';

import {
  NormalFlowDraftToOnCreditsYesComplete,
  NormalFlowDraftToOnCreditsYesIncomplete,
  NormalFlowDraftToOnCreditsNoEcomYes,
  NormalFlowDraftToOnCreditsNoEcomNo,
  NormalFlowOffToOnCreditsYes,
  NormalFlowOffToOnCreditsNoEcomYes,
  NormalFlowOffToOnCreditsNoEcomNo,
  FreemiumFlowDraftToOn,
  FreemiumFlowOffToOnCreditsYesFreeYes,
  FreemiumFlowOffToOnCreditsYesFreeNo,
  FreemiumFlowOffToOnCreditsNoFreeNo,
  FreemiumFlowOffToOnCreditsNoFreeYes,
  OnHoldToOnCreditsYes,
  OnHoldToOnCreditsNoEcomYes,
  OnHoldToOnCreditsNoEcomNo,
  NormalFlowDraftToOnDone,
  NormalFlowOffToOnDone,
  FreemiumFlowOffToOnUsingFreeDone,
  FreemiumFlowOffToOnUsingCreditDone,
  PublishError,
  OnToOff,
  OnToOffDone
} from '.';

function ModalsContainer(props) {
  const {
    modals,
    publish,
    suspend,
    user,
    postings,
    updatePostingAction,
    invalidateCreditsAction,
    updateModalsAction,
    resetModalsAction,
    publishPostingAction,
    resetPublishPostingAction,
    suspendPostingAction,
    resetSuspendPostingAction
  } = props;

  const handleClose = () => {
    resetModalsAction();
  };

  const handlePublish = e => {
    publishPostingAction({
      postingId: modals.selectedPostingId,
      publicationPlan: modals.selectedPlanId
    });
    e.target.setAttribute('disabled', true);
  };

  const handlePublishCleanUp = () => {
    resetModalsAction();
    if (publish.recievedSuccessfulResponse) {
      updatePostingAction({
        postingIndex: modals.selectedPostingIndex,
        status: publish.data.status,
        beginDate: publish.data.beginDate,
        endDate: publish.data.endDate,
        publicationPlan: publish.data.publicationPlan,
        isCompleteRecievedResponse: false
      });
    }
    resetPublishPostingAction();
    invalidateCreditsAction();
  };

  const handlePublishFreemium = e => {
    updateModalsAction({ selectedPlanId: modals.freemiumPlanId });
    publishPostingAction({
      postingId: modals.selectedPostingId,
      publicationPlan: modals.freemiumPlanId
    });
    e.target.setAttribute('disabled', true);
    invalidateCreditsAction();
  };

  const handleSuspend = e => {
    suspendPostingAction({ postingId: modals.selectedPostingId });
    e.target.setAttribute('disabled', true);
  };

  const handleSuspendCleanUp = () => {
    resetModalsAction();
    if (suspend.recievedSuccessfulResponse) {
      updatePostingAction({
        postingIndex: modals.selectedPostingIndex,
        status: suspend.data.status,
        endDate: suspend.data.endDate
      });
    }
    resetSuspendPostingAction();
    invalidateCreditsAction();
  };

  const handleSelectPlan = (selectedPlanId, selectedPlanName) => {
    updateModalsAction({ selectedPlanId, selectedPlanName });
  };

  const isInmobiliaria = user.info.publisherTypeId === '2';
  const freemiumPlans = ['6000', '6001', '6002'];
  const isFreemiumPlan = freemiumPlans.indexOf(modals.selectedPlanId) !== -1;

  return (
    <>
      {modals.modalNameToShow === 'NormalFlowDraftToOnCreditsYes' &&
        postings.isCompleteRecievedResponse &&
        postings.isComplete &&
        !publish.recievedResponse && (
          <NormalFlowDraftToOnCreditsYesComplete
            onClickCancel={handleClose}
            onClickAction={!publish.isLoading ? handlePublish : () => {}}
            onClickSelect={handleSelectPlan}
            defaultPlan={modals.selectedPlanId}
            plans={modals.availablePlans}
          />
        )}

      {modals.modalNameToShow === 'NormalFlowDraftToOnCreditsYes' &&
        postings.isCompleteRecievedResponse &&
        !postings.isComplete &&
        !publish.recievedResponse && <NormalFlowDraftToOnCreditsYesIncomplete postingId={modals.selectedPostingId} />}

      {modals.modalNameToShow === 'NormalFlowDraftToOnCreditsYes' &&
        postings.isCompleteRecievedResponse &&
        publish.recievedSuccessfulResponse && (
          <NormalFlowDraftToOnDone selectedPlanName={modals.selectedPlanName} onClickAction={handlePublishCleanUp} />
        )}

      {modals.modalNameToShow === 'NormalFlowDraftToOnCreditsNoEcomYes' && postings.isCompleteRecievedResponse && (
        <NormalFlowDraftToOnCreditsNoEcomYes
          onClickCancel={handleClose}
          isInmobiliaria={isInmobiliaria}
          postingId={modals.selectedPostingId}
          isComplete={postings.isComplete}
        />
      )}

      {modals.modalNameToShow === 'NormalFlowDraftToOnCreditsNoEcomNo' && postings.isCompleteRecievedResponse && (
        <NormalFlowDraftToOnCreditsNoEcomNo postingId={modals.selectedPostingId} isComplete={postings.isComplete} />
      )}

      {modals.modalNameToShow === 'NormalFlowOffToOnCreditsYes' && !publish.recievedResponse && (
        <NormalFlowOffToOnCreditsYes
          onClickCancel={handleClose}
          onClickAction={!publish.isLoading ? handlePublish : () => {}}
          onClickSelect={handleSelectPlan}
          defaultPlan={modals.selectedPlanId}
          plans={modals.availablePlans}
        />
      )}

      {modals.modalNameToShow === 'NormalFlowOffToOnCreditsYes' && publish.recievedSuccessfulResponse && (
        <NormalFlowOffToOnDone onClickAction={handlePublishCleanUp} selectedPlanName={modals.selectedPlanName} />
      )}

      {modals.modalNameToShow === 'OnToOff' &&
        (!suspend.recievedResponse && (
          <OnToOff onClickCancel={handleClose} onClickAction={!suspend.isLoading ? handleSuspend : () => {}} />
        ))}

      {modals.modalNameToShow === 'OnToOff' && suspend.recievedSuccessfulResponse && (
        <OnToOffDone onClickAction={handleSuspendCleanUp} />
      )}

      {modals.modalNameToShow === 'NormalFlowOffToOnCreditsNoEcomYes' && (
        <NormalFlowOffToOnCreditsNoEcomYes
          onClickCancel={handleClose}
          isInmobiliaria={isInmobiliaria}
          postingId={modals.selectedPostingId}
        />
      )}

      {modals.modalNameToShow === 'NormalFlowOffToOnCreditsNoEcomNo' && (
        <NormalFlowOffToOnCreditsNoEcomNo onClickAction={handleClose} />
      )}

      {modals.modalNameToShow === 'FreemiumFlowDraftToOn' && postings.isCompleteRecievedResponse && (
        <FreemiumFlowDraftToOn
          isComplete={postings.isComplete}
          hasAvailableItems={modals.hasAvailableItems}
          isInmobiliaria={isInmobiliaria}
          postingId={modals.selectedPostingId}
        />
      )}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsYesFreeYes' && !publish.recievedResponse && (
        <FreemiumFlowOffToOnCreditsYesFreeYes
          onClickAction={!publish.isLoading ? handlePublish : () => {}}
          onClickSelect={handleSelectPlan}
          onClickFreemium={!publish.isLoading ? handlePublishFreemium : () => {}}
          plans={modals.availablePlans}
          defaultPlan={modals.selectedPlanId}
          onClickOutside={handleClose}
          isInmobiliaria={isInmobiliaria}
        />
      )}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsYesFreeYes' &&
        isFreemiumPlan &&
        publish.recievedSuccessfulResponse && (
          <FreemiumFlowOffToOnUsingFreeDone
            isInmobiliaria={isInmobiliaria}
            hasAvailableItems={modals.hasAvailableItems}
            onClickAction={handlePublishCleanUp}
          />
        )}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsYesFreeYes' &&
        !isFreemiumPlan &&
        publish.recievedSuccessfulResponse && (
          <FreemiumFlowOffToOnUsingCreditDone
            hasAvailableItems={modals.hasAvailableItems}
            onClickAction={handlePublishCleanUp}
            isInmobiliaria={isInmobiliaria}
          />
        )}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsYesFreeNo' && !publish.recievedResponse && (
        <FreemiumFlowOffToOnCreditsYesFreeNo
          onClickCancel={handleClose}
          onClickAction={!publish.isLoading ? handlePublish : () => {}}
          onClickSelect={handleSelectPlan}
          plans={modals.availablePlans}
          defaultPlan={modals.selectedPlanId}
          isInmobiliaria={isInmobiliaria}
        />
      )}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsYesFreeNo' &&
        isFreemiumPlan &&
        publish.recievedSuccessfulResponse && (
          <FreemiumFlowOffToOnUsingFreeDone
            isInmobiliaria={isInmobiliaria}
            hasAvailableItems={modals.hasAvailableItems}
            onClickAction={handlePublishCleanUp}
          />
        )}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsYesFreeNo' &&
        !isFreemiumPlan &&
        publish.recievedSuccessfulResponse && (
          <FreemiumFlowOffToOnUsingCreditDone
            onClickAction={handlePublishCleanUp}
            isInmobiliaria={isInmobiliaria}
            hasAvailableItems={modals.hasAvailableItems}
          />
        )}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsNoFreeYes' && !publish.recievedResponse && (
        <FreemiumFlowOffToOnCreditsNoFreeYes
          onClickFreemium={!publish.isLoading ? handlePublishFreemium : () => {}}
          onClickAction={handleClose}
          postingId={modals.selectedPostingId}
          isInmobiliaria={isInmobiliaria}
        />
      )}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsNoFreeYes' &&
        (publish.recievedSuccessfulResponse && (
          <FreemiumFlowOffToOnUsingFreeDone
            isInmobiliaria={isInmobiliaria}
            hasAvailableItems={modals.hasAvailableItems}
            onClickAction={handlePublishCleanUp}
          />
        ))}

      {modals.modalNameToShow === 'FreemiumFlowOffToOnCreditsNoFreeNo' && (
        <FreemiumFlowOffToOnCreditsNoFreeNo
          isInmobiliaria={isInmobiliaria}
          onClickCancel={handleClose}
          postingId={modals.selectedPostingId}
        />
      )}

      {modals.modalNameToShow === 'OnHoldToOnCreditsNoEcomYes' && (
        <OnHoldToOnCreditsNoEcomYes
          onClickCancel={handleClose}
          isInmobiliaria={isInmobiliaria}
          postingId={modals.selectedPostingId}
        />
      )}

      {modals.modalNameToShow === 'OnHoldToOnCreditsNoEcomNo' && (
        <OnHoldToOnCreditsNoEcomNo onClickAction={handleClose} isInmobiliaria={isInmobiliaria} />
      )}

      {modals.modalNameToShow === 'OnHoldToOnCreditsYes' && !publish.recievedResponse && (
        <OnHoldToOnCreditsYes
          onClickAction={!publish.isLoading ? handlePublish : () => {}}
          onClickCancel={handleClose}
          onClickSelect={handleSelectPlan}
          plans={modals.availablePlans}
          defaultPlan={modals.selectedPlanId}
          isInmobiliaria={isInmobiliaria}
        />
      )}

      {modals.modalNameToShow === 'OnHoldToOnCreditsYes' && publish.recievedSuccessfulResponse && (
        <NormalFlowOffToOnDone onClickAction={handlePublishCleanUp} selectedPlanName={modals.selectedPlanName} />
      )}

      {publish.recievedResponse && publish.recievedErrorResponse && (
        <PublishError onClickAction={handlePublishCleanUp} />
      )}
    </>
  );
}

const mapDispatchToProps = {
  updatePostingAction: updatePosting,
  invalidateCreditsAction: invalidateCredits,
  updateModalsAction: updateModals,
  resetModalsAction: resetModals,
  publishPostingAction: publishPosting,
  resetPublishPostingAction: resetPublishPosting,
  suspendPostingAction: suspendPosting,
  resetSuspendPostingAction: resetSuspendPosting
};

const mapStateToProps = ({ modals, publish, suspend, user, fetchCredits, postings }) => ({
  modals,
  publish,
  suspend,
  user,
  fetchCredits,
  postings
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalsContainer);
